import styled from 'styled-components'

export const BasketPageStyle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding-bottom: 3em;

  .introText {
    font-size: 1em;
    max-width: 50em;
  }

  .footerText {
    /* font-size: small; */
    font-size: 1em;
    max-width: 50em;
  }
`

export const HeaderWrapper = styled.div`
  padding-left: 20px;
  background: rgb(158, 224, 148);
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  @media (max-width: 600px) {
    width: 85%;
    display: flex;
    margin: auto;
    margin-top: 3em;
  }
  width: 600px;
  margin-top: 3em;
  align-items: center;
  .cardWrapper {
    width: 75%;
  }
`
export const ContentWrapperStandAlone = styled.div`
  display: flex;
  font-size: small !important;
  flex-direction: column;
  margin: auto;
  @media (max-width: 600px) {
    width: 100%;
    display: flex;
    margin: auto;
    margin-top: 3em;
  }
  width: 700px;
  margin-top: 3em;
  align-items: center;
  .cardWrapper {
    width: 75%;
  }
`
export const ButtonContainer = styled.div`
  margin-top: 1em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  button {
    margin: 0.5em 1em;
  }
`
